import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { id: String, name: String }

  connect() {
    const selectize = document.querySelector("#assignment_client_company_id").selectize

    if (!selectize.options[this.idValue]) {
      selectize.addOption({ value: this.idValue, text: this.nameValue })
    }

    selectize.addItem(this.idValue)

    this.element.remove() // keep DOM clean
  }
}
